import { lazy } from "react";

const PagesRoutes = [
  // MAIN
  {
    path: "/main/dashboard/analytics",
    component: lazy(() => import("../../view/main/dashboard/analytics")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/main/dashboard/nfes/summary",
    component: lazy(() => import("../../view/main/dashboard/nfes-summary")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/main/dashboard/nfes/summary/detail/:id",
    component: lazy(() => import("../../view/main/dashboard/nfes-summary")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/main/dashboard/nfes",
    component: lazy(() => import("../../view/main/dashboard/nfes")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/main/dashboard/nfes/detail/:id",
    component: lazy(() => import("../../view/main/dashboard/nfes")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/main/dashboard/nfes/import",
    component: lazy(() => import("../../view/main/dashboard/nfes-import")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  // APPS
  {
    path: "/apps/contact",
    component: lazy(() => import("../../view/apps/contact")),
    layout: "VerticalLayout",
  },

  {
    path: "/apps/contact/contact-detail",
    component: lazy(() => import("../../view/apps/contact")),
    layout: "VerticalLayout",
  },

  {
    path: "/apps/users",
    component: lazy(() => import("../../view/apps/users")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/apps/branch",
    component: lazy(() => import("../../view/apps/branch")),
    layout: "VerticalLayout",
  },
  {
    path: "/apps/branch/detail",
    component: lazy(() => import("../../view/apps/branch")),
    layout: "VerticalLayout",
  },

  {
    path: "/apps/supplier",
    component: lazy(() => import("../../view/apps/supplier")),
    layout: "VerticalLayout",
  },
  {
    path: "/apps/supplier/detail",
    component: lazy(() => import("../../view/apps/supplier")),
    layout: "VerticalLayout",
  },

  {
    path: "/apps/product",
    component: lazy(() => import("../../view/apps/product")),
    layout: "VerticalLayout",
  },
  {
    path: "/apps/product/detail",
    component: lazy(() => import("../../view/apps/product")),
    layout: "VerticalLayout",
  },
  {
    path: "/apps/product-filter",
    component: lazy(() => import("../../view/apps/product-filter")),
    layout: "VerticalLayout",
  },
  {
    path: "/apps/product-filter/detail",
    component: lazy(() => import("../../view/apps/product-filter")),
    layout: "VerticalLayout",
  },

  // ACESSO NEGADO (AllNube)
  {
    path: "/pages/acesso-negado",
    component: lazy(() => import("../../view/pages/acesso-negado")),
    layout: "FullLayout",
    auth: false,
    exact: true,
  },

  // SUPERADMIN
  {
    path: "/pages/superadmin",
    component: lazy(() => import("../../view/pages/superadmin")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/pages/log-auditoria-geral",
    component: lazy(() => import("../../view/pages/log-auditoria-geral")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },

  // PAGES
  {
    path: "/pages/faq",
    component: lazy(() => import("../../view/pages/faq")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/pages/pricing",
    component: lazy(() => import("../../view/pages/pricing")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/pages/profile/personel-information",
    component: lazy(() => import("../../view/pages/profile")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/pages/profile/notifications",
    component: lazy(() => import("../../view/pages/profile")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/pages/profile/activity",
    component: lazy(() => import("../../view/pages/profile")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/pages/profile/security",
    component: lazy(() => import("../../view/pages/profile")),
    auth: true,
    exact: true,
    layout: "VerticalLayout",
  },
  {
    path: "/pages/profile/password-change",
    component: lazy(() => import("../../view/pages/profile")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/pages/profile/connect-with-social",
    component: lazy(() => import("../../view/pages/profile")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },

  {
    path: "/pages/landing",
    component: lazy(() => import("../../view/pages/landing")),
    layout: "FullLayout",
    auth: false,
  },
  {
    path: "/pages/authentication/login",
    component: lazy(() => import("../../view/pages/authentication/login")),
    layout: "FullLayout",
    auth: false,
  },
  {
    path: "/pages/authentication/recover-password",
    component: lazy(() =>
      import("../../view/pages/authentication/recover-password")
    ),
    layout: "FullLayout",
    auth: false,
  },
  {
    path: "/pages/authentication/register",
    component: lazy(() => import("../../view/pages/authentication/register")),
    layout: "FullLayout",
    auth: false,
  },
  {
    path: "/pages/authentication/reset-password/:uid/:token",
    component: lazy(() =>
      import("../../view/pages/authentication/reset-password")
    ),
    layout: "FullLayout",
    auth: false,
  },
  {
    path: "/pages/error-403",
    component: lazy(() => import("../../view/pages/errors/403")),
    layout: "FullLayout",
  },
  {
    path: "/pages/error-404",
    component: lazy(() => import("../../view/pages/errors/404")),
    layout: "FullLayout",
  },
  {
    path: "/pages/error-500",
    component: lazy(() => import("../../view/pages/errors/500")),
    layout: "FullLayout",
  },
  {
    path: "/pages/error-502",
    component: lazy(() => import("../../view/pages/errors/502")),
    layout: "FullLayout",
  },
  {
    path: "/pages/error-503",
    component: lazy(() => import("../../view/pages/errors/503")),
    layout: "FullLayout",
  },
  // Apex
  {
    path: "/analytics/supplier",
    component: lazy(() => import("../../view/apex/analytics-supplier")),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/analytics/supplier-participation",
    component: lazy(() =>
      import("../../view/apex/analytics-supplier-participation")
    ),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/analytics/concentration-products",
    component: lazy(() =>
      import("../../view/apex/analytics-concentration-products")
    ),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
  {
    path: "/analytics/purchase-frequency",
    component: lazy(() =>
      import("../../view/apex/analytics-purchase-frequency")
    ),
    layout: "VerticalLayout",
    auth: true,
    exact: true,
  },
];

export default PagesRoutes;
